import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import {
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';

import { useDispatch, useSelector } from 'react-redux';
import { getSliders, sliderThunk } from '../../../redux/appearanceSlice';

const SliderView = ({ Accordions, handleChange, expanded, isImage, isVideo }) => {
   const dispatch = useDispatch()
    const {sliders} = useSelector((state)=>state.appearances)


    
    useEffect(()=>{
        dispatch(getSliders())
    },[])

    const formik = useFormik({
        initialValues: {
            sliders: sliders?.data[0]?.sliders || [{
                    title: '',
                    description: '',
                    image: '',
                    buttonText: '',
                    buttonLink: '',
                },
            ]  
        },
       
        onSubmit: (values) => {
          
        },
    });

  
  

    useEffect(() => {
        if (sliders?.data[0]?.sliders) {
            formik.setValues({ sliders: sliders.data[0].sliders });
        }
    }, [sliders]);

    
    
    return (
        <form>
            <Accordions
                sx={{ marginBottom: "20px" }}
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography
                        sx={{
                            fontSize: "16px",
                            color: "#1D1F2C",
                        }}
                    >
                        Sliders
                    </Typography>
                </AccordionSummary>

                <AccordionDetails
                    sx={{
                        background: '#F0F1F3B2',
                        margin: "0px 20px 20px 20px",
                    }}
                >
                    {formik.values?.sliders?.map((slider, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                            <label className={styles.addCatLabel}>
                                Slider {index + 1}
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <input
                                        type="text"
                                        name={`sliders[${index}].title`}
                                        className={styles.addCatInput}
                                        placeholder="Enter title"
                                        value={slider.title}
                                        disabled={true}
                                        style={{background:'white'}}
                                    />
                                    
                                </div>
                              
                            </label>

                            <label className={styles.addCatLabel}>
                                Description
                                <input
                                    type="text"
                                    name={`sliders[${index}].description`}
                                    className={styles.addCatInput}
                                    placeholder="Enter description"
                                    value={slider.description}
                                    disabled={true}
                                    style={{background:'white'}}

                                />
                              
                            </label>



                            <div className={styles.imageUpload}>
                                <p className={styles.addCatLabel}>Image</p>
                            
                                        {slider.image ? 
                                            <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center',background:'white' }}>
                                                {isImage(slider.image) && (
                                                    <img src={slider.image} alt="Preview" className={styles.previewImage} />
                                                )}
                                                {isVideo(slider.image) && (
                                                    <video controls className={styles.previewImage}>
                                                        <source src={slider.image} type="video/mp4" />
                                                    </video>
                                                )}
                                               
                                            </div>
                                        :null}
                            </div>


                            <label className={styles.addCatLabel} >
                                Button link
                                <div style={{ display: 'flex', alignItems: "center", gap: '10px' }}>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="Button link"
                                            className={styles.addCatInput}
                                            name={`sliders[${index}].buttonText`}
                                            value={slider.buttonText}
                                            disabled={true}
                                            style={{background:'white'}}
                                        />

                                    </div>

                                    <div style={{ display: 'flex', alignItems: "center", width: "80%" }}>
                                        <div className={styles.https}>https://</div>
                                        <input
                                            type="text"
                                            placeholder="Add Redirection Link Here "
                                            className={styles.addCatInput}
                                            name={`sliders[${index}].buttonLink`}
                                            value={slider.buttonLink}
                                            disabled={true}
                                            style={{ borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", marginTop: "10px",background:'white' }}
                                        />
                                    </div>
                                </div>



                            </label>
                        </div>
                    ))}

                   
                </AccordionDetails>
            </Accordions>
        </form>
    );
};

export default SliderView;
